import React from "react";
import { Modal } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import MyIcon from "../Common/MyIcon";
import InfoIcon from "../../assets/icons/Icon_Library/application icons/general/movable.svg2";
import DetailsForSolutionModals from "../Solutions/DetailsForSolutionModals";
import {
  SolutionClientType,
  SolutionType,
  useGetImportedSolutionInfoByUuidQuery,
} from "../store/slices/settingsSlice";

export default function SolutionInfoRouteModal() {
  const { clientSolutionUuid } = useParams<{ clientSolutionUuid: string }>();
  const navigate = useNavigate();
  const response = useGetImportedSolutionInfoByUuidQuery(
    { uuid: clientSolutionUuid || "" },
    { skip: !clientSolutionUuid }
  );
  const solution = response.data?.LatestSource?.Solution as
    | SolutionType
    | undefined;
  const clientSolution = clientSolutionUuid
    ? ({
        ...response.data,
        Uuid: clientSolutionUuid,
        WasDeployed: Boolean(response.data?.WasDeployed),
      } as SolutionClientType)
    : undefined;
  const closeModal = () => navigate("/library/solutions/purchased");

  return (
    <Modal show onHide={closeModal} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          <div className="d-flex align-items-center svg-white">
            <MyIcon Icon={InfoIcon} width={30} />
            <span className="ms-3 fs-3 fw-bold">Solution Information</span>
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {response.isLoading ? (
          <div className="d-flex justify-content-center p-5">
            <div className="spinner-border" role="status" />
          </div>
        ) : solution && clientSolution ? (
          <DetailsForSolutionModals
            solution={solution}
            clientSolution={clientSolution}
            useRouteModal
          />
        ) : (
          <div className="alert alert-danger m-0">
            Unable to load this purchased solution.
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
}
